'use strict';

angular.module('shiftTraderApp')
    .controller('DaysOffManagementModalCtrl', function($scope, TimeService, DaysOffStore, params, GlobalRxFeed,
                                                       DaysOffManagementModalService, $uibModalInstance) {
    $scope.me = params.me;
    $scope.org = params.org;

    $scope.allUsers = params.allUsers;

    $uibModalInstance.rendered.then(function () {
      GlobalRxFeed.push('modal-opened', 'days-off-management', $uibModalInstance)
    })

    $scope.allDepartments = _.map($scope.org.departments, function(dept) {
      dept._selected = true;
      return dept;
    });

    $scope.close = function() {
      $uibModalInstance.close();
    };

    $scope.currentDate = DaysOffManagementModalService.getCurrentDate();

    var firstWeek = TimeService.getWeekTwixFromMoment($scope.currentDate);

    $scope.weeks = _.map([0,1,2,3,4,5], function(x) {
      return (moment(firstWeek.start).add(x, 'weeks')).twix(moment(firstWeek.start).add(x+1, 'weeks'));
    });

    //clip it down to the last week that has a day in the current month
    _.each([5,4], function(x) {
      if (!$scope.weeks[1].start.isSame($scope.weeks[x].start, 'month')) {
        $scope.weeks.splice(x,1);
      }
    });

    var currentViewDateRange = $scope.weeks[0].start.twix($scope.weeks[$scope.weeks.length-1].end);

    // grab the data from the day off store for the whole month in advance
    DaysOffStore.getDaysOffBetween(currentViewDateRange.start, currentViewDateRange.end)
      .then(function(records) {
        $scope.daysOff = records;

        if (params.selectedDayOffId) {
          DaysOffManagementModalService.setSelectedDayOffId(params.selectedDayOffId);
        }

      }, function() {
        console.log('well, we had an issue loading the days off');
      });

  });
